import { render } from "./MatchByWinners.vue?vue&type=template&id=2ed0aee7"
import script from "./MatchByWinners.vue?vue&type=script&lang=js"
export * from "./MatchByWinners.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__